import { render, staticRenderFns } from "./ModalActiveIngredient.vue?vue&type=template&id=3a17b510&scoped=true&"
import script from "./ModalActiveIngredient.vue?vue&type=script&lang=js&"
export * from "./ModalActiveIngredient.vue?vue&type=script&lang=js&"
import style0 from "./ModalActiveIngredient.vue?vue&type=style&index=0&id=3a17b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17b510",
  null
  
)

export default component.exports